/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateDietTypeRequest
 */
export interface UpdateDietTypeRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateDietTypeRequest
     */
    'dietType'?: UpdateDietTypeRequestDietTypeEnum;
}

export const UpdateDietTypeRequestDietTypeEnum = {
    LowCarb: 'LOW_CARB',
    Balanced: 'BALANCED',
    Vegan: 'VEGAN',
    HighProtein: 'HIGH_PROTEIN',
    Keto: 'KETO',
    GlutenFree: 'GLUTEN_FREE'
} as const;

export type UpdateDietTypeRequestDietTypeEnum = typeof UpdateDietTypeRequestDietTypeEnum[keyof typeof UpdateDietTypeRequestDietTypeEnum];


